/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import './animation013.less';
import { usePlayFlag } from './../../components/topicScroll';
import arrow from '../../../../../assets/arrow.png';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation013Item {
  icon?: string;
  title: string;
  content: [];
}

const bgTemplate = [
  'rgba(234, 75, 108, 1)',
  'rgba(243, 162, 104, 1)',
  'rgba(111, 129, 247, 1)',
  'rgba(12, 163, 163, 1)',
];

const getBG = (feed: number) => bgTemplate[feed % bgTemplate.length];
const getImg = (img: string) => require(`../../../../../assets/${img}`).default;

interface IAnimation013Props {
  items: IAnimation013Item[];
  style?: React.CSSProperties;
  title?: string | null;
  className?: string | null;
  onCompleted?: () => void;
}

const Animation013: React.FunctionComponent<IAnimation013Props> = ({
  title,
  items,
  style,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation013 onCompleted');
      onCompleted && onCompleted();
    }
  };

  React.useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };
  return (
    <div
      ref={crrRef}
      className={`animation013 component ${className}`}
      style={style}
    >
      {title && (
        <div
          className="animation013-title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      <div className="animation013-content">
        {items.map((itm: IAnimation013Item, idx: number) => (
          <div
            onClick={() => clickToPlay()}
            key={idx}
            className={`animation013-item  animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            style={{ width: `${(1 / items.length) * 100}%` }}
          >
            <img
              className="click-point"
              onClick={() => clickToPlay()}
              style={{
                display: play <= 1 ? 'block' : 'none',
              }}
              src={ImgPoint}
              alt=""
            />
            <div
              className="animation013-header"
              style={{
                backgroundColor: getBG(idx),
              }}
            >
              {itm.icon && (
                <div className="icon">
                  <img src={getImg(itm.icon)} alt="" />
                </div>
              )}
              <span dangerouslySetInnerHTML={{ __html: itm.title }} />
              <div className="arrow">
                <img src={arrow} alt="" />
              </div>
            </div>
            <div className="animation013-content">
              <ul>
                {itm.content.map((itms: string, idxs: number) => (
                  <div
                    className={`animation013-text animation013-text${idx + 1} `}
                    key={idxs}
                    dangerouslySetInnerHTML={{ __html: itms }}
                  />
                ))}
              </ul>
            </div>
            {/* {itm.content?(
            <div
              className="animation013-text"
              dangerouslySetInnerHTML={{ __html: itm.content[] }}
            />
            )
            :null} */}
          </div>
        ))}
      </div>
    </div>
  );
};

Animation013.defaultProps = {
  style: {},
  title: null,
};

export default Animation013;
